import React from "react";
import { SectionTitle } from "@components";
import { useAppDispatch, useAppSelector } from "@hooks";
import { setCV } from "@store";
import { HeadingIds } from "@constants";
import { createEducationNewPoint } from "@utils";
import { EducationNewList } from "./EducationNewList";
import { fields } from "./localization";
import commonStyles from "../../CV.common.scss";
export function EducationNew() {
    var _a;
    const dispatch = useAppDispatch();
    const { cv } = useAppSelector((state) => state.cv);
    const { language } = useAppSelector((state) => state.ui);
    const field = fields(language);
    const educationNew = ((_a = cv === null || cv === void 0 ? void 0 : cv.educationNewDisplay) === null || _a === void 0 ? void 0 : _a.length)
        ? cv.educationNewDisplay
        : [createEducationNewPoint()];
    const setEducationNew = (educationNewDisplay) => {
        dispatch(setCV(Object.assign(Object.assign({}, cv), { educationNewDisplay })));
    };
    const handleAdd = () => {
        if (educationNew.length === 0) {
            setEducationNew([createEducationNewPoint(), createEducationNewPoint()]);
        }
        else {
            setEducationNew([...educationNew, createEducationNewPoint()]);
        }
    };
    return (React.createElement("section", { id: HeadingIds.EducationNew, className: commonStyles.section },
        React.createElement(SectionTitle, { title: field.title, subtitle: field.subtitle, required: true, handleAdd: handleAdd, addButtonLabel: field.addEducation }),
        React.createElement(EducationNewList, { items: educationNew, onEdit: setEducationNew })));
}
